import { AfterViewChecked, ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthServiceService } from './shareModule/services/auth-service.service';
import { RedirectionService } from './shareModule/services/redirection.service';
import { NavigationEnd, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';

//import { getToken, onMessage } from 'firebase/messaging';
import { filter, Subject, takeUntil } from 'rxjs';

import { SocketService } from './socket.service';
import { SharedService } from './shareModule/services/shared.service';
import { MemberNotificationService } from './shareModule/services/member-notification.service';
import { AppState } from './shareModule/states/app.state';
import { Store } from '@ngrx/store';
import { loadBizCategory } from './shareModule/states/biz-category';
import { loadBizBrand } from './shareModule/states/biz-brand';
import { loadCommunityProductCategory } from './shareModule/states/community-product-category';
import { SeoService } from './shareModule/services/seo.service';
import { loadNews } from './shareModule/states/news';
declare const gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements AfterViewChecked, OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    public auth: AuthServiceService,
    private _redirectionService: RedirectionService,
    private router: Router,
    private viewportScroller: ViewportScroller,
    private store: Store<AppState>,
    private sharedService: SharedService,
    private memberNotitifcationService: MemberNotificationService,
    private seoService: SeoService, //this is for just creating the service/connection not used here
    private socketService: SocketService,
  ) {
    // this.checkHashInUrl();
    this.socketService.init();
  }
  private readonly NAV_COUNT_KEY = 'navigationCount'

  ngOnDestroy(): void {
    console.log("[Start Destroy] APP COMPONENT")
    if (this.sharedService.isBrowser()) {
      sessionStorage.removeItem(this.NAV_COUNT_KEY);
    }
    this.destroy$.next();
    this.destroy$.complete();
    console.log("[End Destroy] APP COMPONENT")
  }

  private markNavigation() { //used for back button to home if no history found. search navigationCount to see the code that uses thsi
    sessionStorage.removeItem(this.NAV_COUNT_KEY)
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((e: NavigationEnd) => {

      const isInternalNavigation = e.urlAfterRedirects.startsWith('/') || e.urlAfterRedirects.startsWith(window.location.origin);

      if (isInternalNavigation) {
        sessionStorage.setItem(this.NAV_COUNT_KEY, (Number(sessionStorage.getItem(this.NAV_COUNT_KEY) ?? 0) + 1).toString());
      } else {
        sessionStorage.removeItem(this.NAV_COUNT_KEY)
      }
    });
  }

  private registerBehoreUnloadAction() {
    // window.addEventListener("beforeunload", (e) => {
    //const navigationCount = Number(sessionStorage.getItem(this.NAV_COUNT_KEY) ?? 0);

    // if(navigationCount <= 1){
    // e.preventDefault(); //don't exit the applicaton
    //e.returnValue =''; 
    //NEEDS FIX VERY ANNOYING CURRENTLY
    //}
    //sessionStorage.setItem(this.NAV_COUNT_KEY, `${navigationCount - 1}`);

    // })
  }

  ngOnInit(): void {
    this.seoService.createCanonicalURL();
    if (this.sharedService.isBrowser()) {
      this.markNavigation();
      this.trackPage();
      this.checkAndRemoveHash();
      this.memberNotitifcationService.registerDevice();
      this.auth.registerVisit(`${window.innerHeight}x${window.innerWidth}`).subscribe({ error: console.error });
      this.registerBehoreUnloadAction();

      const excludedRoute = [
        'www.fusionapp.store',
        'www.sgbojio.com',
        'www.brands4good.asia',
        'www.ezcart.app',
        'www.corporatepromo.sg',
        'www.combuu.com',
        'www.myvip.asia',
      ];

      if (excludedRoute.includes(window.location.hostname))
        this.seoService.updateNoIndex(true);


      this.seoService.updateSchema('organization')
    }
    // this.store.dispatch(loadBizCategory());
    // this.store.dispatch(loadBizBrand());
    this.store.dispatch(loadCommunityProductCategory());
    // this.store.dispatch(
    //   loadNews({
    //     adminId: 0,
    //     isAdmin: false,
    //     page: 1,
    //     isPopular: 1,
    //     category: '',
    //     hashtag: '',
    //     pageSize: 12,
    //   })
    // );

  }

  ngAfterViewChecked(): void {
    // this.router.events
    //   .pipe(
    //     filter(
    //       (event): event is NavigationEnd => event instanceof NavigationEnd
    //     )
    //   )
    //   .subscribe(() => {
    //     if (this.sharedService.isBrowser()) {
    //       this.seoService.removeSchema()
    //       const [x, y] = this.viewportScroller.getScrollPosition();
    //       // this.viewportScroller.scrollToPosition([x, y + 50]); // Adjust as needed
    //       if (x != null && y != null) {
    //         this.viewportScroller.scrollToPosition([x, y + 50]);
    //       } else {
    //         console.error('x or y is null or undefined', { x, y });
    //       }
    //     }
    //   });
  }

  checkHashInUrl() {
    // Check if the current URL does not contain the hash symbol
    if (!window.location.hash) {
      const currentUrl = window.location.pathname + window.location.search;
      const newUrl = '/#' + currentUrl;
      window.location.href = newUrl; // Redirect to hash-based URL
    }
  }

  private checkAndRemoveHash(): void {
    if (typeof window !== 'undefined') {
      const currentUrl = window.location.href;
      if (currentUrl.includes('#')) {
        this.router.navigateByUrl(currentUrl.split('#')[1], { replaceUrl: true });
      }
    }
  }

  trackPage() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-33R5J2G5EY', {
          page_path: event.urlAfterRedirects,
        });
      }
    });
  }
}
